__turbopack_context__.v({
  "container": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__container",
  "eyebrow": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__eyebrow",
  "header": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__header",
  "hpv2Blink": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2Blink",
  "hpv2DemoBounce": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2DemoBounce",
  "hpv2DemoFadeIn": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2DemoFadeIn",
  "hpv2DemoProgress": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2DemoProgress",
  "hpv2DemoScaleIn": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2DemoSlideIn",
  "hpv2FadeLeft": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2FadeLeft",
  "hpv2FadeRight": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2FadeRight",
  "hpv2FadeUp": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2FadeUp",
  "hpv2FloatA": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2FloatA",
  "hpv2FloatB": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2FloatB",
  "hpv2HeroFadeIn": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2PriceShimmer",
  "hpv2PulseDot": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2PulseDot",
  "hpv2ScaleUp": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__hpv2ScaleUp",
  "title": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__title",
  "titleHighlight": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__titleHighlight",
  "titleLine": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__titleLine",
  "viewMoreBtn": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__viewMoreBtn",
  "viewMoreWrap": "AvailableLoadsSectionV2-module-scss-module__YE6XWW__viewMoreWrap",
});
